module.exports = __webpack_public_path__ + "static/img/94007C_2_3_4_R_20190118_LC.3d93be0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/94007C_2_3_4_R_20190118_LC.png
// module id = gYKR
// module chunks = 0